import React, { useState, useEffect } from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import axios from "axios";

const API_BASE = 'https://cleezoclass.com:8443/api';

const CustomerSupportData = () => {


    const [schoolMouDetails, setSchoolMouDetails] = useState([])
    const [schoolDetails, setSchoolDetails] = useState([]);
    const [schoolDetailsLoading, setSchoolDetailsLoading] = useState(false)
    const [schoolDetailsError, setSchoolDetailsError] = useState("")
    const [followup, setFollowup] = useState([])

    const [schoolMouDetailsLoading, setSchoolMouDetailsLoading] = useState(false);
    const [schoolMouDetailsError, setSchoolMouDetailsError] = useState("");
    const [contactPersonPopUp, setContactPersonPopUp] = useState(false)
    const [contactPerson, setContactPerson] = useState({
        person_to_contact: "",
        person_to_contact_number: "",
        following_person: localStorage.getItem("empName"),
    })
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedSchoolIds, setSelectedSchoolIds] = useState({
        mouId: null,
        centralizationId: null,
    });
    const [schoolFilter, setSchoolFilter] = useState(""); // To filetr the school name



    // To load MOU updated schools details
    useEffect(() => {
        setSchoolMouDetailsLoading(true);


        axios.get(`${API_BASE}/cse/mou-forms`)
            .then((response) => {
                console.log("MOU API DATA:", response.data);

                setSchoolMouDetails(response.data);
            })
            .catch((error) => {
                console.error(error);
                setSchoolMouDetailsError("Failed to load school details");
            })
            .finally(() => {
                setSchoolMouDetailsLoading(false);
            });
    }, []);

    console.log("moudetails :", schoolMouDetails)

    //To load centralization Schools details
    useEffect(() => {
        setSchoolDetailsLoading(true);


        axios.get(`${API_BASE}/cse/centralization`)
            .then((response) => {
                setSchoolDetails(response.data);
            })
            .catch((error) => {
                console.error(error);
                setSchoolDetailsError("Failed to load school details");
            })
            .finally(() => {
                setSchoolDetailsLoading(false);
            });
    }, []);

    useEffect(() => {
        axios.get(`${API_BASE}/follow-ups-all`)
            .then((response) => {
                setFollowup(response.data);

            })
            .catch((error) => {
                console.error(error);
            })
    }, [])

    console.log("followUp :", followup)



    // to merger the MOU Schools and Centralized schools

    const normalizeSchoolName = (name) =>
        (name || "")
            .trim()
            .toLowerCase()
            .replace(/[^\w\s]/g, "")
            .replace(/\s+/g, " ");

    const schoolMap = new Map();

    // First load MOU schools
    schoolMouDetails.forEach((school) => {
        const key = normalizeSchoolName(school.schoolName);

        schoolMap.set(key, {
            source: "mou",
            originalId: school.id,

            mouId: school.id,
            centralizationId: null,

            schoolName: school.schoolName,

            admin:
                school.contactPerson ||
                "-",

            adminPhone:
                school.phone ||
                "-",

            person_to_contact:
                school.person_to_contact ||
                "-",

            person_to_contact_number:
                school.person_to_contact_number ||
                "-",

            empName:
                school.empName ||
                "-",

            following_person:
                school.following_person ||
                "-",
        });
    });

    // Merge Centralization schools
    schoolDetails.forEach((school) => {
        const key = normalizeSchoolName(
            school.institute_name
        );

        if (schoolMap.has(key)) {
            const existing = schoolMap.get(key);

            schoolMap.set(key, {
                ...existing,

                centralizationId: school.id,
                admin:
                    existing.admin !== "-"
                        ? existing.admin
                        : school.institute_authorized_person,

                adminPhone:
                    existing.adminPhone !== "-"
                        ? existing.adminPhone
                        : school.institute_contact_number,

                person_to_contact:
                    existing.person_to_contact !== "-"
                        ? existing.person_to_contact
                        : school.person_to_contact,

                person_to_contact_number:
                    existing.person_to_contact_number !== "-"
                        ? existing.person_to_contact_number
                        : school.person_to_contact_number,

                empName:
                    existing.empName !== "-"
                        ? existing.empName
                        : school.empName,

                following_person:
                    existing.following_person !== "-"
                        ? existing.following_person
                        : school.following_person,
            });
        } else {
            schoolMap.set(key, {
                source: "centralization",
                originalId: school.id,

                mouId: null,
                centralizationId: school.id,
                schoolName: school.institute_name,

                admin:
                    school.institute_authorized_person ||
                    "-",

                adminPhone:
                    school.institute_contact_number ||
                    "-",

                person_to_contact:
                    school.person_to_contact ||
                    "-",

                person_to_contact_number:
                    school.person_to_contact_number ||
                    "-",

                empName:
                    school.empName ||
                    "-",

                following_person:
                    school.following_person ||
                    "-",
            });
        }
    });
    const mergedSchools = Array.from(
        schoolMap.values()
    ).map((school) => {

        const matchedFollowups = followup
            .filter(
                (f) =>
                    normalizeSchoolName(f.institutename).includes(
                        normalizeSchoolName(school.schoolName)
                    ) ||
                    normalizeSchoolName(school.schoolName).includes(
                        normalizeSchoolName(f.institutename)
                    )
            )
            .sort(
                (a, b) =>
                    new Date(b.date) - new Date(a.date)
            );





        const latestFollowup = matchedFollowups.sort(
            (a, b) =>
                new Date(b.date) - new Date(a.date)
        )[0];

        return {
            ...school,
            empName: latestFollowup?.empName || school.empName || "-"
        };
    });


    const handlePopupInputChange = (e) => {
        const { name, value } = e.target;

        setContactPerson((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // To Update the School's Contact person

    const contactPersonAddPopUp = (mouId, centralizationId) => {

        setSelectedSchoolIds({
            mouId,
            centralizationId,
        });

        setContactPerson({
            person_to_contact: "",
            person_to_contact_number: "",
            following_person: localStorage.getItem("empName"),
        });

        setContactPersonPopUp(true);
    };

    const handleSubmit = async () => {
        try {
            setSuccessMessage("");
            setErrorMessage("");

            const payload = {
                mouId: selectedSchoolIds.mouId,
                centralizationId: selectedSchoolIds.centralizationId,
                person_to_contact: contactPerson.person_to_contact,
                person_to_contact_number: contactPerson.person_to_contact_number,
                following_person: contactPerson.following_person,

            };

            const response = await axios.post(` ${API_BASE}customer-support/update`, payload);

            if (response.status === 200 || response.status === 201) {

                setSchoolMouDetails((prev) =>
                    prev.map((school) =>
                        school.id === selectedSchoolIds.mouId
                            ? {
                                ...school,
                                person_to_contact: contactPerson.person_to_contact,
                                person_to_contact_number: contactPerson.person_to_contact_number,
                                following_person: contactPerson.following_person,
                            }
                            : school
                    )
                );
                // person_to_contact,person_to_contact_number
                setSchoolDetails((prev) =>
                    prev.map((school) =>
                        school.id === selectedSchoolIds.centralizationId
                            ? {
                                ...school,
                                person_to_contact: contactPerson.person_to_contact,
                                person_to_contact_number: contactPerson.person_to_contact_number,
                                following_person: contactPerson.following_person,
                            }
                            : school
                    )
                );

                setSuccessMessage("Details saved successfully.");

                setTimeout(() => {
                    setContactPersonPopUp(false);
                }, 1000);
            }

        } catch (error) {
            console.error(error);
            setErrorMessage("Failed to save details.");
        }
    };

    const missingEmpNames = mergedSchools.filter(
        (s) => s.empName === "-"
    );

    console.log("Mergered Data :", mergedSchools)

    const filteredSchools = mergedSchools.filter((school) =>
        school.schoolName
            ?.toLowerCase()
            .includes(schoolFilter.toLowerCase())
    );

    return (
        <div className="mainBlock">
            <h2>Customer Support Exicutive</h2>
            <CustomerSupportAside />
            <div className="cust-spt-conatiner">
                <h1>Data</h1>

                {schoolMouDetailsLoading && (
                    <p>Loading school details...</p>
                )}
                {schoolMouDetailsError && (
                    <p className="error-message">
                        {schoolMouDetailsError}
                    </p>
                )}
                <div className="cust-spt-data-table">
                    <div style={{ marginBottom: "15px" }}>
                        <input
                            type="text"
                            placeholder="Search School Name..."
                            value={schoolFilter}
                            onChange={(e) => setSchoolFilter(e.target.value)}
                            style={{
                                padding: "8px",
                                width: "300px",
                                border: "1px solid #ccc",
                                borderRadius: "4px"
                            }}
                        />
                    </div>
                    <table className="sales-performance-table">

                        <thead>
                            <tr>
                                <th>School Name</th>
                                <th>Authorizes Person</th>
                                <th>Contact Number</th>
                                <th>Person To Contact</th>
                                <th>Contact Number</th>
                                <th>Signied Person</th>
                                <th>Following Person</th>
                            </tr>
                        </thead>
                        <tbody>

                            {/* {schoolMouDetails.map((school) => (
                                <tr key={school.schoolId}>
                                    <td className="cust-spt-data-schlName"
                                        onClick={() => contactPersonAddPopUp(school.schoolId)}>{school.schoolName}</td>
                                    <td>{school.contactPerson}</td>
                                    <td>{school.phone}</td>
                                    <td>{school.person_to_contact || "-"}</td>
                                    <td>{school.person_to_contact_number || "-"}</td>
                                    <td>{school.empName}</td>
                                    <td>{school.following_person}</td>
                                </tr>
                            ))}
                            {schoolDetails.map((school) => (
                                <tr key={school.schoolId}>
                                    <td className="cust-spt-data-schlName"
                                        onClick={() => contactPersonAddPopUp(school.schoolId)}>{school.institute_name}</td>
                                    <td>{school.institute_authorized_person}</td>
                                    <td>{school.institute_contact_number}</td>
                                    <td>{school.person_to_contact || "-"}</td>
                                    <td>{school.person_to_contact_number || "-"}</td>
                                    <td>{school.empName}</td>
                                    <td>{school.following_person}</td>
                                </tr>))} */}

                            {filteredSchools.map((school) => (
                                <tr key={`${school.source}-${school.originalId}`}>
                                    <td
                                        className="cust-spt-data-schlName"
                                        onClick={() =>
                                            contactPersonAddPopUp(
                                                school.mouId,
                                                school.centralizationId)}
                                    >
                                        {school.schoolName}
                                    </td>

                                    <td>{school.admin}</td>
                                    <td>{school.adminPhone}</td>
                                    <td>{school.person_to_contact || "-"}</td>
                                    <td>{school.person_to_contact_number || "-"}</td>
                                    <td>{school.empName}</td>
                                    <td>{school.following_person}</td>
                                </tr>
                            ))}



                        </tbody>
                    </table>
                    {contactPersonPopUp &&
                        <div className="contact-person-overlay">
                            {/* onClick={(prev) => setContactPersonPopUp(!prev)}> */}
                            <div className="contact-person-popup">
                                <div className="cust-spt-followup">
                                    <table className="cust-spt-followup-table">
                                        <tbody>
                                            <tr>
                                                <td>Person to contact</td>
                                                <td>:</td>
                                                <td><input type="text" name="person_to_contact" value={contactPerson.person_to_contact} onChange={(e) => handlePopupInputChange(e)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Contact Number</td>
                                                <td>:</td>
                                                <td><input type="number" maxLength={10} name="person_to_contact_number" value={contactPerson.person_to_contact_number} onChange={(e) => handlePopupInputChange(e)} /></td>
                                            </tr>
                                            {/* <tr>
                                                <td>Comment</td>
                                                <td>:</td>
                                                <td><textarea value={contactPerson.comment} name="comment" onChange={(e) => handlePopupInputChange(e)} /></td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                                <button onClick={(prev) => setContactPersonPopUp(!prev)}
                                    className="CloseContactPersonBtn">X</button>

                                {successMessage && (
                                    <p className="success-message">{successMessage}</p>
                                )}
                                {errorMessage && (
                                    <p className="error-message">{errorMessage}</p>
                                )}

                                <div className="cust-spt-submitBlock">
                                    <button className="cust-spt-submitButtom"
                                        onClick={() => handleSubmit()}>Submit</button>

                                </div>
                            </div>

                        </div>}
                </div>

            </div>

        </div>
    )
}
export default CustomerSupportData;